import { createSlice } from '@reduxjs/toolkit';
import { STATUS, SUPPORTED_REGIONS } from '../../../shared/enums';

export const initialState = {
  data: {
    region: SUPPORTED_REGIONS.EU,
  },
  status: STATUS.IDLE,
  error: null,
};


export const localizationSlice = createSlice({
  name: 'localization',
  initialState,
  reducers: {
    setRegions: (state, action) => {
      state.data.region = action.payload;
    },
  },
});

export const selectLocalizationData = state => state.localization.data;

export const { setRegions } = localizationSlice.actions;

export default localizationSlice.reducer;
